import React, { useEffect, useState } from "react";
import { CARD_MODE_STORAGE_KEY, CARD_MODE_EVENT } from "../../../utils/cardDisplaySettings";
import ProviderProductCard from "../components/ProviderProductCard";
import { elakayAutoText as text } from "../../pageInside/dataElakay";
import "./ui.css";

// Responsive product grid: 2 columns on phones -> 3 tablet -> 4 laptop -> 5 large desktop
// (same breakpoints as the Buyer sliders: 2 / 3 / 4 / 4 / 5).
export const GridSkeleton = ({ count = 8 }) => (
  <div className="pgrid" aria-busy="true" role="status"><span className="spm-sr-only">{text("h_spm_loading", "Loading products…")}</span>
    {Array.from({ length: count }, (_, i) => <div className="pgrid__skeleton" key={i} aria-hidden="true" />)}</div>
);

// Portrait / Landscape, from the Filter drawer's toggle: same localStorage key + event as the Buyer grids.
const readMode = () => { try { return window.localStorage.getItem(CARD_MODE_STORAGE_KEY) === "landscape" ? "landscape" : "portrait"; } catch { return "portrait"; } };
export const useCardMode = () => {
  const [mode, setMode] = useState(readMode);
  useEffect(() => {
    const on = (e) => setMode(e?.detail?.mode === "landscape" ? "landscape" : "portrait");
    window.addEventListener(CARD_MODE_EVENT, on);
    return () => window.removeEventListener(CARD_MODE_EVENT, on);
  }, []);
  return mode;
};

export default function ProductGrid({ products = [], loading = false, empty, showProvider = true }) {
  const mode = useCardMode();
  if (loading && !products.length) return <GridSkeleton />;
  if (!products.length) return <div className="dsi-state-card">{empty || <p>{text("h_pg_empty", "No products match your criteria.")}</p>}</div>;
  return <div className={`pgrid${mode === "landscape" ? " pgrid--landscape" : ""}`}>{products.map((p) => <ProviderProductCard key={p._id} product={p} variant="browse" showProvider={showProvider} />)}</div>;
}
